const More03Icon = /*#__PURE__*/ [
  ["rect", { x: "18", y: "18", width: "3", height: "3", rx: "1", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["rect", { x: "18", y: "10.5", width: "3", height: "3", rx: "1", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["rect", { x: "18", y: "3", width: "3", height: "3", rx: "1", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["rect", { x: "10.5", y: "18", width: "3", height: "3", rx: "1", stroke: "currentColor", strokeWidth: "1.5", key: "3" }],
  ["rect", { x: "10.5", y: "10.5", width: "3", height: "3", rx: "1", stroke: "currentColor", strokeWidth: "1.5", key: "4" }],
  ["rect", { x: "10.5", y: "3", width: "3", height: "3", rx: "1", stroke: "currentColor", strokeWidth: "1.5", key: "5" }],
  ["rect", { x: "3", y: "18", width: "3", height: "3", rx: "1", stroke: "currentColor", strokeWidth: "1.5", key: "6" }],
  ["rect", { x: "3", y: "10.5", width: "3", height: "3", rx: "1", stroke: "currentColor", strokeWidth: "1.5", key: "7" }],
  ["rect", { x: "3", y: "3", width: "3", height: "3", rx: "1", stroke: "currentColor", strokeWidth: "1.5", key: "8" }]
];

export { More03Icon as default };
//# sourceMappingURL=More03Icon.js.map
